import React from "react";
import {
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { EditingReasonSolution } from "../types";
import {
  newReasonSolutionFormStyles,
  editReasonSolutionFormStyles,
  formTitleStyles,
  formContentStyles,
  numberInputStyles,
  textInputWithMinWidthStyles,
  previousReasonInputStyles,
  buttonStyles,
  errorTextStyles,
  checkboxStyles,
} from "../styles";

interface ReasonSolutionFormProps {
  editingReasonSolution: EditingReasonSolution;
  reasonSolutionError: string;
  isEditing: boolean;
  onSave: () => void;
  onCancel: () => void;
  onRowChange: (value: number) => void;
  onIsPrimaryChange: (value: boolean) => void;
  onReasonChange: (value: string) => void;
  onSolutionChange: (value: string) => void;
  onPreviousReasonIdsChange: (value: string) => void;
}

export const ReasonSolutionForm: React.FC<ReasonSolutionFormProps> = ({
  editingReasonSolution,
  reasonSolutionError,
  isEditing,
  onSave,
  onCancel,
  onRowChange,
  onIsPrimaryChange,
  onReasonChange,
  onSolutionChange,
  onPreviousReasonIdsChange,
}) => {
  if (!editingReasonSolution.stageId) {
    return null;
  }

  const formStyles = isEditing
    ? editReasonSolutionFormStyles
    : newReasonSolutionFormStyles;
  const title = isEditing
    ? "ویرایش علت و راه‌حل:"
    : "افزودن علت و راه‌حل جدید:";

  return (
    <Box sx={formStyles}>
      <Typography variant="subtitle2" sx={formTitleStyles}>
        {title}
      </Typography>
      <Box sx={formContentStyles}>
        <TextField
          size="small"
          label="ردیف"
          type="number"
          value={editingReasonSolution.row}
          onChange={(e) => onRowChange(parseInt(e.target.value) || 1)}
          inputProps={{ min: 1 }}
          sx={numberInputStyles}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={editingReasonSolution.isPrimary}
              onChange={(e) => onIsPrimaryChange(e.target.checked)}
            />
          }
          label="اصلی"
          sx={checkboxStyles}
        />

        <TextField
          size="small"
          label="علت"
          value={editingReasonSolution.reason}
          onChange={(e) => onReasonChange(e.target.value)}
          sx={textInputWithMinWidthStyles}
        />

        <TextField
          size="small"
          label="راه‌حل"
          value={editingReasonSolution.solution}
          onChange={(e) => onSolutionChange(e.target.value)}
          sx={textInputWithMinWidthStyles}
        />

        <TextField
          size="small"
          label="علت بعدی"
          value={editingReasonSolution.previousReasonIdsJson}
          onChange={(e) => onPreviousReasonIdsChange(e.target.value)}
          placeholder="1 5 7"
          sx={previousReasonInputStyles}
        />

        <Button
          onClick={onSave}
          variant="contained"
          size="small"
          color="primary"
          sx={buttonStyles}
        >
          ذخیره
        </Button>

        <Button
          onClick={onCancel}
          variant="outlined"
          size="small"
          sx={buttonStyles}
        >
          انصراف
        </Button>
      </Box>
      {reasonSolutionError && (
        <Typography variant="caption" color="error" sx={errorTextStyles}>
          {reasonSolutionError}
        </Typography>
      )}
    </Box>
  );
};
